import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="container">
        <h1>About SnapTools</h1>
        <div className="about-content">
          <section className="about-section">
            <h2>Our Mission</h2>
            <p>
              SnapTools is a free, browser-based image editing platform designed to provide users with
              powerful image manipulation tools without requiring downloads, installations, or uploads to external servers.
            </p>
            <p>
              Our mission is to make image editing accessible to everyone, while respecting your privacy and data security.
            </p>
          </section>
          
          <section className="about-section">
            <h2>How It Works</h2>
            <p>
              All SnapTools utilities run entirely in your browser using JavaScript and the HTML5 Canvas API.
              Your images never leave your device and are processed locally, ensuring maximum privacy and security.
            </p>
            <p>
              This also means you can use our tools offline once the page has loaded!
            </p>
          </section>
          
          <section className="about-section">
            <h2>Our Tools</h2>
            <p>
              SnapTools offers a comprehensive suite of image editing tools including compression, resizing, cropping,
              format conversion, effects and filters, rotation, watermarking, HTML to image conversion, face blurring, and meme generation.
            </p>
            <p>
              All our tools are designed to be easy-to-use, fast, and effective, providing professional-quality results without requiring
              advanced technical skills.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage; 